import { LDProvider } from "launchdarkly-react-client-sdk-original";
import { suspend } from "suspend-react";

import { flags } from "views/flags";

import { FlagsList } from "./FlagsList";
import { isLDClientReady, useLDClient } from "../LaunchDarkly";

const DevToolsFlags = () => {
  const ldClient = useLDClient();

  suspend(isLDClientReady);

  return (
    <LDProvider
      ldClient={ldClient}
      clientSideID={process.env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID!}
      flags={flags}
    >
      <FlagsList />
    </LDProvider>
  );
};

export default DevToolsFlags;
